var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.backImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }